import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { handleViewClose } from "../../redux/Reducer/ModalSlice";

const ViewModal = ({ children, ModalWidth, ModalTitle }) => {
  const view = useSelector((state) => state.Modal.view);
  const dispatch = useDispatch();
  return (
    <Dialog
      open={view}
      fullWidth={true}
      maxWidth={ModalWidth}
    // className="entries"
    >
      <DialogTitle className="entries" sx={{ display: "flex", justifyContent: "space-between" }}>
        <span
          style={{
            color: "#4187e8",
          }}
        >
          {ModalTitle}
        </span>
        <CloseIcon
          sx={{ mt: "5px", cursor: "pointer" }}
          onClick={() => {
            dispatch(handleViewClose());
          }}
        />
      </DialogTitle>
      <DialogContent dividers style={{ padding: " 0px" }}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default ViewModal;
